import SDIcon from './SDIcon'

const IconCarbonTaskAdd = (props) => (
  <SDIcon title='TaskAdd' {...props}>
    <polygon points='31 24 27 24 27 20 25 20 25 24 21 24 21 26 25 26 25 30 27 30 27 26 31 26 31 24' />
    <path d='M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2H17V28H7V7h3v3H22V7h3v9h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z' />
  </SDIcon>
)

export default IconCarbonTaskAdd
